'use strict';
/*
    Displays recommendations on an autocompleter field.
    Requires `autocompleter` directive as parent.
*/
namespace Autocompleter {

    class AutocompleterRecommendations {
        private data: any[];
        private recommendationType: number;
        private parentCtrl: any;
        private isHoliday: boolean;
        private acMethods: any = {};

        constructor (
            private $scope: any,
            private $route: ng.route.IRouteService,
            private $timeout: ng.ITimeoutService,
            private $q: ng.IQService,
            private resourceService: Core.ResourceService,
            private autocompleter: any,
            private houseRecommender: any
        ) {

        }

        init (ac: any): void {
            this.parentCtrl = ac;
            this._wrapAcMethod('focus', this.load);
            this._wrapAcMethod('select', this.select);
        }

        load (): void {
            if (this.allow()) {
                this.fetch().then(destinations => {
                    if (destinations) {
                        this.$timeout(() => {
                            if (this.allow()) {
                                // Set `data` on autocompleter
                                this.parentCtrl.data = destinations;
                            }
                            // Set `initialData` on autocompleter
                            // Repopulates menu when no search term i.e. <3 chars
                            this.parentCtrl.initialData = destinations;

                            this._unwrapAcMethod('focus');
                        });
                    }
                });
            }
        }

        select (dest: any): boolean | undefined {
            if (dest && this.allow()) {
                const currentArea = this.$route.current ? this.$route.current.area : '';
                let ac: any = this.parentCtrl;
                let area = ac.areaOverride || currentArea;
                let destTitle = dest && dest.Title;

                if (destTitle) {
                    ac.loading = true;
                    ac.prefix = destTitle;
                    ac.data = null;

                    // Fetch autocompleter item data on select
                    this.autocompleter.lookup(area, destTitle)
                        .then(res => {
                            let item = res && res.data && res.data[0];
                            if (item) {
                                // Call original non-wrapped method
                                this.acMethods.select(item);
                                this.houseRecommender.trackHouseClick(dest);
                            }
                            else {
                                ac.prefix = '';
                                ac.data = null;
                                ac.$emit('flash:error', this.resourceService.get('NOMATCHES'));
                            }
                            ac.loading = false;
                        });
                }
                return true; // Block wrapped ac.select()
            }
        }

        allow (): boolean {
            let prefix = this.parentCtrl.prefix;
            return !prefix || prefix.length < this.parentCtrl.minPrefix;
        }

        fetch (): ng.IPromise<any> {
            // `houseRecommendationService` has its own caching
            return this.houseRecommender.getHouseRecs()
                .then((dests: any) => {
                    const destinations = _.filter(
                        dests,
                        (d:any) => d.searchable && (!this.isHoliday || (this.isHoliday && d.holidayEnabled))
                    );
                    if (destinations && destinations.length) {
                        destinations.splice(0, 0, {
                            Title: this.resourceService.get('RECOMMENDED'),
                            header: true
                        });
                        this.recommendationType = dests[0].Type;
                        return _.map(destinations, d => {
                            if (!d.header) {
                                d.Title = d.title;
                                d.EstablishmentCount = d.estabCount;
                            }
                            return d;
                        });
                    }
                });
        }

        private _wrapAcMethod (method: string, fn: Function) {
        // Original method doesn't run if `fn()` returns `true`
            let m = this.parentCtrl[method];
            if (m) {
                this.acMethods[method] = m;
            }
            this.parentCtrl[method] = (...args: any[]) => {
                let v = fn.apply(this, args);
                if (m && v !== true) {
                    return m.apply(this.parentCtrl, args);
                }
            };
        }

        private _unwrapAcMethod (method: string) {
            let m = this.acMethods[method];
            if (m) {
                delete this.acMethods[method];
            }
            this.parentCtrl[method] = m; // May be undefined
        }
    };

    angular
        .module('TR')
        .directive('autocompleterRecommendations', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                controller: AutocompleterRecommendations,
                controllerAs: 'acr',
                bindToController: {
                    isHoliday: '='
                },
                require: '^autocompleter',
                link: (
                    scope: any,
                    el: JQuery,
                    attr: ng.IAttributes,
                    autocompleterCtrl: any
                ) => {
                    scope.acr.init(autocompleterCtrl);
                }
            };
        });
}
